module.exports = __webpack_public_path__ + "front/img/10_7.d58da4f7.png";